module.exports = __webpack_public_path__ + "860088dea654274230c38796ef8706c6.svg";